import React from 'react';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { fontFamily } from 'components/views/default';

type CellProps = {
    isActive: boolean;
}
const Cell = styled.div<CellProps>(props => ({
    display: 'flex',
    alignItems: 'center',
    backgroundColor: props.isActive ? 'white' : 'transparent',
    color: props.isActive ? '#333' : '#C2C2C2',
    fontSize: '14px',
    padding: '15px 20px',
    ':hover': {
        backgroundColor: 'white',
        color: '#333',
    },
    ':active': {
        color: '#333',
    },
}));

const Icon = styled(FontAwesomeIcon)({
    marginRight: '8px',
    color: '#60636B',
    fontSize: '1.3em',
    ':active': {
        color: '#333',
    },
});

const Label = styled.span({
    fontSize: '0.95em',
    fontWeight: 600,
    fontFamily,
});

export type SidebarMenuItemProps = {
    name: string;
    icon: IconDefinition;
    active: boolean;
    onClick: () => void;
}

export const SidebarMenuItem = (props: SidebarMenuItemProps) => {
    const { name, icon, active, onClick } = props;
    return (
        <Cell isActive={active} onClick={() => onClick()}>
            <Icon icon={icon} />
            <Label>{name}</Label>
        </Cell>
    );
};
